import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { ChecklistApiResponse, ChecklistUpdatePayload } from '../models/checklist.model';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ChecklistService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.backofficeApiUrl}/api/v1/contracts`;

  // Subject per comunicare la richiesta di apertura della checklist
  private openChecklistRequestSubject = new Subject<void>();
  public openChecklistRequest$ = this.openChecklistRequestSubject.asObservable();

  // Track if checklist is available (contract has been saved)
  private checklistAvailableSubject = new BehaviorSubject<boolean>(false);
  public checklistAvailable$ = this.checklistAvailableSubject.asObservable();

  /**
   * Get checklist for a contract
   * @param contractId Contract ID
   */
  getChecklist(contractId: string): Observable<ChecklistApiResponse> {
    return this.http.get<ChecklistApiResponse>(`${this.apiUrl}/${contractId}/checklist`);
  }

  /**
   * Update checklist for a contract
   * @param contractId Contract ID
   * @param checklistId Checklist ID
   * @param payload Update payload with rows
   */
  updateChecklist(
    contractId: string,
    checklistId: number,
    payload: ChecklistUpdatePayload
  ): Observable<ChecklistApiResponse> {
    return this.http.patch<ChecklistApiResponse>(
      `${this.apiUrl}/${contractId}/checklist/${checklistId}`,
      payload
    );
  }

  /**
   * Request to open the checklist dialog
   */
  requestOpenChecklist(): void {
    this.openChecklistRequestSubject.next();
  }

  /**
   * Set checklist availability (called when contract is saved)
   * @param available Whether checklist is available
   */
  setChecklistAvailability(available: boolean): void {
    this.checklistAvailableSubject.next(available);
  }

  /**
   * Reset checklist availability (called on component destroy)
   */
  resetChecklistAvailability(): void {
    this.checklistAvailableSubject.next(false);
  }
}
